import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import ReceptionistDashboard from '@/pages/receptionist/Dashboard';

/** Queue Management (same as receptionist) — Sales Manager only for that hospital. */
export default function SalesManagerQueueManagementPage() {
  const { user } = useAuth();
  if (user?.role !== 'SALES_MANAGER') {
    return <Navigate to="/sales-person/dashboard" replace />;
  }
  return <ReceptionistDashboard />;
}
